import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'

import '../styles/Breadcrumb.scss'

import { Id } from 'util/types/index'
import { ApplicationState } from 'AppReducer'

type Breadcrumb = { name: string, to: string }
type Path = { name: string, getName?: (id: Id) => string | undefined, children: PathChain[] }
type PathChain = {
  [x: string]: Path
}

const BreadcrumbComponent: React.FC = () => {
  const { partner } = useSelector((state: ApplicationState) => state.partnerReducer)
  const { product } = useSelector((state: ApplicationState) => state.partnerProductReducer)

  const paths: PathChain = {
    panel: {
      name: 'Início',
      children: [
        {
          partner: {
            name: 'Parceiros',
            children: [
              {
                '([0-9]+)': {
                  name: 'Parceiro',
                  getName: (id: Id): string => partner?.id === Number(id) ? partner?.name : '',
                  children: [
                    {
                      config: {
                        name: 'Configuração',
                        children: [
                          {
                            product: {
                              name: 'Produtos',
                              children: [
                                {
                                  '([0-9]+)': {
                                    name: 'Produto',
                                    getName: (id: Id): string => (
                                      product?.id === Number(id) ? product?.product.name : ''
                                    ),
                                    children: [
                                      { config: { name: 'Configuração', children: [] } }
                                    ]
                                  }
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          }
        }
      ]
    }
  }

  const [breadcrumb, setBreadcrumb] = useState<Breadcrumb[]>([])
  const { pathname } = useLocation()
  const parts = pathname.split('/').filter(item => !!item)

  function getPath (path: string, paths: PathChain[]): Path | undefined {
    let find

    paths.forEach(item => {
      const key = Object.keys(item)[0]
      if (key === path) {
        find = item[path]
      } else if (new RegExp(key).test(path)) {
        find = item[key]
      }
    })

    return find
  }

  function loopPath (index: number, paths: PathChain[], breadcrumb: Breadcrumb[] = []): Breadcrumb[] {
    const part = parts[index]
    if (part) {
      const path = getPath(part, paths)
      if (path) {
        const link = parts.slice(0, index + 1).join('/')
        breadcrumb.push({ name: path.getName?.(part) || path.name, to: `/${link}` })
        return loopPath(index + 1, path.children, breadcrumb)
      }
    }

    return breadcrumb
  }

  const createBreadcrumb = useCallback(() => {
    const response = loopPath(0, [paths])
    setBreadcrumb(response)
    // eslint-disable-next-line
  }, [paths])

  useEffect(() => {
    createBreadcrumb()
    // eslint-disable-next-line
  }, [pathname, partner, product])

  if (breadcrumb.length < 4) return null

  return (
    <div className="row breadcrumb">
      {
        breadcrumb.map((item, i) => (
          <NavLink to={item.to} key={i} style={{ zIndex: breadcrumb.length - i }}>
            <span>{ item.name }</span>
          </NavLink>
        ))
      }
    </div>
  )
}

export default BreadcrumbComponent
